import axios from 'axios';
import router from '@/router';
import store from '@/store'
import { Loading } from 'element-ui';
import APIs from '@/api'; // 导入APIs
import util from '@/utils/util'
import { Message } from 'element-ui';
import i18n from '@/i18n/index'

// 创建axios实例
const service = axios.create({
  baseURL: "/",
  withCredentials: true, // 携带cookies
});

// HTTP 层失败的提示文案。不按状态码逐个写文案 —— 状态码穷举不完，
// 而且对用户来说 500 和 502 是同一件事（后端挂了，等会儿再来），
// 分得再细也不改变他下一步的动作。只分「有没有拿到响应」这一刀：
// 拿不到是网络/超时，用户自己能处理；拿到了就把码原样带出去，
// 截图里有码，排查的人一眼知道是网关挂了还是接口路径错了
function httpErrorText(error) {
  const status = error.response ? error.response.status : 0
  if (!status) {
    const msg = String(error.message || '')
    if (error.code === 'ECONNABORTED' || msg.indexOf('timeout') !== -1) {
      return i18n.t('http.timeout')
    }
    return i18n.t('http.netError')
  }
  return String(i18n.t('http.failedWithCode')).replace('%s', status)
}

// 同一条提示短时间内只弹一次。一个页面常常并发好几个请求（数据页是 6 张趋势图
// 加表格加卡片），后端挂了的话它们会在同一秒里各弹一条一模一样的 toast 刷满屏
let lastToast = ''
let lastToastAt = 0
function toastOnce(text) {
  const now = Date.now()
  if (text === lastToast && now - lastToastAt < 2000) return
  lastToast = text
  lastToastAt = now
  Message({ message: text, type: 'error' })
}

// 请求拦截器
service.interceptors.request.use(config => {
  // 如果是post请求，设置content-type为json
  config.headers['Authorization'] =  util.getCookie("token") // 让每个请求携带token--['Authorization', 'Bearer
  console.log("国内为什么没有token", util.getCookie("token"))
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response;
}, error => {
  // 失败一律弹一次 toast。以前这里只是原样往下抛，而调用点基本都不接 .catch，
  // 结果 502 这类错误在界面上只表现为「转圈转不停」，用户不知道发生了什么。
  // 主动取消（切页面、换筛选条件重发）不是错误，不弹
  if (!axios.isCancel(error)) {
    error.__toasted = true
    toastOnce(httpErrorText(error))
  }
  return Promise.reject(error);
});

// 创建loading的引用
let loadingInstance;

function safePush(path) {
  if (router.currentRoute.path !== path) {
    router.push(path);
  }
}

// 封装请求函数
function ajax({ type, url, data, fn, errorFn, loading }) {
  return new Promise((resolve, reject) => {
    // 判断如果是海外项目，则url更改为海外api地址
    if(window.location.hash.indexOf("#/abroad") !== -1) {
      url = url.replace("/api", "/abroadApi")
    }
    
    // 创建请求配置
    let requestConfig = {
      method: type,
      url: url,
      data: type === 'get' ? null : data,
      params: type === 'get' ? data : null,
    };



    if (loading) {
      loadingInstance = Loading.service({ lock: true, text: '加载中...' });
    }

    service(requestConfig)
      .then(res => {
        if (loadingInstance) {
          loadingInstance.close();
        }
        if (Number(res.data.code) === 0) {
          resolve(res.data.data)
          fn && fn(res.data.data)
        } else if (Number(res.data.code) === 1) {
          resolve(res.data)
          fn && fn(res.data)
        } else {
          if(Number(res.data.code) === 2000) {
            Message({
              message: res.data.msg,
              type: 'error',
            });
            store.commit('$_removeStorage');
            router.push({path:'/login'});
          } else if(Number(res.data.code) === 2001) {
            let user = JSON.parse(util.getCookie("user"))
            // 如果是海外跳转到海外，国内跳转到国内
            if(user.area == 1) {
              safePush('/app/list');
            } else {
              safePush('/abroad/app/list');

            }
          } else {
              errorFn && errorFn(res.data.msg);
          }
        }
      })
      .catch(err => {
        if (loadingInstance) {
          loadingInstance.close();
        }
        if (axios.isCancel(err)) {
          console.error('Request canceled', err.message);
        } else {
          // 不是 HTTP 层的失败（响应体不是预期的 JSON、上面回调里自己抛了异常……）
          // 拦截器没弹过，这里补一次，不让任何一种失败悄无声息
          if (!err.__toasted) {
            toastOnce(i18n.t('http.failed'))
          }
          reject(err);
        }
      });
  });
}


export default {
  getData: (api, params, fn, errorFn, loading) => ajax({ type: 'get', url: APIs[api], data: params, fn, errorFn, loading }),
  postData: (api, data, fn, errorFn, loading) => ajax({ type: 'post', url: APIs[api], data, fn, errorFn, loading }),
  putData: (api, data, fn, errorFn, loading) => ajax({ type: 'put', url: APIs[api], data, fn, errorFn, loading }),
};